import { useState, useCallback } from 'react';
import { ProcessField, CustomProcessField } from 'types/dataTableTypes';

export const useFieldModals = () => {
  const [fieldModal, setFieldModal] = useState<{
    type: 'add' | 'edit';
    initialField?: ProcessField | CustomProcessField;
  }>();
  const [fieldToDelete, setFieldToDelete] = useState<
    ProcessField | CustomProcessField
  >();

  const handleAddField = useCallback(() => {
    setFieldModal({ type: 'add' });
  }, []);

  const handleEditField = useCallback(
    (field: ProcessField | CustomProcessField) => {
      setFieldModal({ type: 'edit', initialField: field });
    },
    []
  );

  const handleDeleteField = useCallback(
    (field: ProcessField | CustomProcessField) => {
      setFieldToDelete(field);
    },
    []
  );

  return {
    fieldModal,
    setFieldModal,
    fieldToDelete,
    setFieldToDelete,
    handleAddField,
    handleEditField,
    handleDeleteField,
  };
};
